module.exports = __webpack_public_path__ + "img/perfil-jaleklinico.ad9ed9ca.png";